import { CustomerItemDto, CustomerPropertiesDto } from '@/api/generated';
import { useAddCustomerContact } from '@/views/customerDetails/util/useAddCustomerContact.util.ts';
import { useDeleteCustomerContact } from '@/views/customerDetails/util/useDeleteCustomerContact.util.ts';

type CommonReturn = {
  contactId: number;
  customer?: Omit<CustomerItemDto, 'address'> | null;
};

type Return = {
  setContactCustomer: (params: CommonReturn) => Promise<void>;
  updateContactCustomer: (
    params: CommonReturn & {
      customerChanged: boolean;
      initialCustomerId?: CustomerPropertiesDto['customerId'];
    },
  ) => Promise<void>;
};

export const useUpdateContactCustomer = (): Return => {
  const { addCustomerContact } = useAddCustomerContact({ disableSuccessAlert: true });
  const { deleteCustomerContact } = useDeleteCustomerContact({ disableSuccessAlert: true });

  return {
    setContactCustomer: async ({ contactId, customer }) => {
      if (!customer) {
        return;
      }
      await addCustomerContact({
        contactId,
        customerId: customer.customerId,
      });
    },
    updateContactCustomer: async ({ contactId, customer, customerChanged, initialCustomerId }) => {
      if (!customerChanged) {
        return;
      }
      if (initialCustomerId !== undefined && initialCustomerId !== null) {
        await deleteCustomerContact({
          contactId,
          customerId: initialCustomerId,
        });
      }
      if (customer) {
        await addCustomerContact({
          contactId,
          customerId: customer.customerId,
        });
      }
    },
  };
};
